import React, { ReactNode } from 'react';

function PageContainer({ children }: { children: ReactNode }) {
  return (
    <div className="container mx-auto px-4 xl:max-w-[1128px]">{children}</div>
  );
}

export default React.memo(PageContainer);
